module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAXCAYAAACWEGYrAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACdSURBVHgB7ZfhCcIwEEafZjFHcZPeBrqCm5ybdBNNiQdpsRYs6NeSBx/JJX8ed+RHYId0OY+cC6KEYESOqaAhRhNcSxNcSxP8hkO1HwStqvucG0KcGXdQKkc2QD1uo4w86BEbd2CMW90hQJrUTunu6VXHeuePpDdnjphomjl3hETThztHRDQt3DsCokuSA47gY5rDEP8+BEYRvPJDnl78Y1Htimj3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = P9/e
// module chunks = 1